import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemoveKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRemoveKeyframe"><Path fillRule="evenodd" clipRule="evenodd" d="M1.18945 12.0001L12.0001 1.18945L22.8108 12.0001L12.0001 22.8108L1.18945 12.0001ZM9 11.25V12.75H15V11.25H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRemoveKeyframe;
